import { ClaimItemDeleteAdapter } from '../../../adapter';

export default async function ClaimItemDeleteUseCase(event) {
    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcc.dev.bpimsapps.com');
    const isUAT = url.includes('hcc.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionclaims.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
        ? 'https://partners-api.dev.bpimsapps.com/claim/claim-item/save'
        : isUAT
        ? 'https://partners-api.uat.bpimsapps.com/claim/claim-item/save'
        : isProd
        ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/claim-item/save`
        : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/claim-item/save`;

    const payload = {
        claimItems: [
            {
                id: event.id,
                txnClaimId: 1
            }
        ]
    };

    // handle request
    const result = await ClaimItemDeleteAdapter(endpoint, JSON.stringify(payload));

    return result;
}
